import {
  isoStringToDateTransform,
  Model,
  modelAction,
  tProp,
  types,
} from "mobx-keystone";
import { AddressModel } from "../../address/model.address";
import { UtilityAccountStatus, UtilityType } from "../../enums";
import { utilityNS } from "./ns";
import type { Self } from "../../../lib/models/ref";

@utilityNS.model
export class UtilityServiceAccountModel extends Model({
  type: tProp(types.enum(UtilityType)),
  status: tProp(types.maybeNull(types.enum(UtilityAccountStatus))),
  addressRaw: tProp(types.string),
  address: tProp(types.maybeNull(AddressModel)),
  updatedAt: tProp(types.dateString).withTransform(isoStringToDateTransform()),
}) {
  @modelAction
  protected _setValueForKey<K extends keyof this & keyof Self<this>>(
    key: K,
    value: Self<this>[K] | this[K],
  ): void {
    this[key] = value;
  }
}
